module.exports = __webpack_public_path__ + "static/article-slide-1-7eb3a4b0504c156bc6e6c8d5999424b1.jpg";